var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 57.198,
    height: 47.892,
    viewBox: "0 0 57.198 47.892",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2379 47.781)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,77.866V116.75c0,2.477,1.727,4.5,3.838,4.5H53.36c2.111,0,3.838-2.027,3.838-4.5V77.866c0-2.477-1.727-4.5-3.838-4.5H3.838C1.727,73.362,0,75.389,0,77.866Z",
    transform: "translate(2379 -121.143)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.494,106.972v40.176a.127.127,0,0,0,.1.116H83.562a.128.128,0,0,0,.1-.116V106.972a.127.127,0,0,0-.1-.116H33.6A.128.128,0,0,0,33.494,106.972Z",
    transform: "translate(2349.248 -150.895)",
    fill: "#1f2e3d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.971,205.423l-11.607-6.991a2.132,2.132,0,0,0-3.232,1.826v13.982a2.132,2.132,0,0,0,3.232,1.826l11.607-6.991A2.132,2.132,0,0,0,233.971,205.423Z",
    transform: "translate(2179.344 -235.05)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2387.271 -14.303)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74.047,336.943H99.558a1.611,1.611,0,1,1,0,3.223H74.047Z",
    transform: "translate(-64.111 -335.217)",
    fill: "#99a9cb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.439,336.943h8.325v3.222h-8.325a1.611,1.611,0,1,1,0-3.222Z",
    transform: "translate(-316.828 -335.217)",
    fill: "#d51968"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.073)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M309.964,328.185a.863.863,0,0,0,.863-.863v-4.968a.863.863,0,0,0-1.726,0v4.968A.863.863,0,0,0,309.964,328.185Z",
    transform: "translate(-309.101 -321.491)",
    fill: "#d51968"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/video.148a294fbde76875091188a7827009c5.svg";
export { ForwardRef as ReactComponent };